export const enum AutoshipTemplateStatusEnum {
    ARCHIVED = 0,
    ACTIVE = 1
}